import * as React from 'react';

import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_LEFT__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_LEFT__12';

export class FlagsMenu extends React.Component {
    handleClickBack = () => {
        this.props.setActiveMenu('tray');
    }

    render() {
        return (
            <div className="site-header-tray__menu">
                <div className="site-header-tray__menu-header" >
                    <span
                        className="site-header-tray__menu-back"
                        onClick={this.handleClickBack}
                        onKeyPress={this.handleClickBack}
                        role="button"
                        tabIndex={0}
                    ><SVGIcon markup={CHEVRON_LEFT__12}/> {this.props.flags.back}</span>
                </div>
                <div className="site-header-tray__menu-items">
                    {this.props.flags.items.map((item) => (
                        <a className={`site-header-tray__menu-item-link site-header-tray__menu-item-link--flag ${item.countryCode}`} data-bypass="true" href={item.link} key={`${item.countryCode}-${item.link}`}>
                            <i aria-hidden="true" className={`site-header-tray__menu-item-icon flag-${item.countryCode}`} />
                            <span className="site-header-tray__menu-item-text">{item.text}</span>
                        </a>
                    ))}
                </div>
            </div>
        );
    }
}
